module.exports = __webpack_public_path__ + "static/img/pagination-prev-icon.2f3ff27d.svg";